import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { fetchDataProcessingAgreement, LegalDocument } from '@/src/services/legalService';

export const DataProcessingAgreementScreen: React.FC = () => {
  const [dpaData, setDpaData] = useState<LegalDocument | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetchDataProcessingAgreement().then(data => {
      if (active) {
        setDpaData(data);
        setLoading(false);
      }
    });
    return () => { active = false; };
  }, []);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-20 bg-[#3a3430]">
        <div className="w-12 h-12 border-2 border-white/20 border-t-[#F26522] rounded-full animate-spin mb-4"></div>
        <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/60 font-heading">Syncing GDPR Compliance...</p>
      </div>
    );
  }

  return (
    <div className="bg-[#3a3430] text-white p-6 md:p-10 flex flex-col h-full animate-in fade-in duration-200" id="dpa-screen-container">
      <header className="border-b border-white/[0.06] pb-4 mb-6 shrink-0 flex flex-col md:flex-row md:items-end md:justify-between gap-3">
        <div>
          <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#F26522] block mb-1 font-heading">eNvesta AI Legal</span>
          <h2 className="text-2xl font-bold tracking-tight font-heading text-white leading-none">Data Processing Agreement</h2>
        </div>
        <div className="text-left md:text-right">
          <span className="text-[10px] font-medium uppercase tracking-widest text-white/60 block font-heading">Version: {dpaData?.version || '1.0.0'}</span>
          <span className="text-[10px] text-white/40 block mt-0.5">Effective: {dpaData?.effectiveDate || 'June 15, 2026'}</span>
        </div>
      </header>

      <div className="flex-1 overflow-y-auto max-h-[50vh] pr-2 text-sm text-white/70 leading-relaxed space-y-4 no-scrollbar border-b border-white/[0.06] mb-6" id="dpa-content-scroller">
        <div className="markdown-body prose prose-invert max-w-none">
          <ReactMarkdown>{dpaData?.content || ''}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
};
